module.exports = __webpack_public_path__ + "img/banner1.0d58e305.jpg";